import React from "react";
import KeywordsTag from './KeywordsTag';

const Hospital = ({ yearsIsVisible, monthsIsVisible, keywordsIsVisible }) => (
    <KeywordsTag
        tagId="hospitalpublic"
        handwritingSrc="../../content/handwriting/hospital.png"
        handwritingAlt="hospital"
        yearsIsVisible={yearsIsVisible}
        monthsIsVisible={monthsIsVisible}
        keywordsIsVisible={keywordsIsVisible}
    />
);

export default Hospital;